import { filterData, log } from '../../utils/helpers'

export const ContactUsPayload = (formData) => {
  log('ContactUsPayload', formData)
  return {
    'name': formData.name,
    'email': formData.email,
    'subject': formData.subject,
    'message': formData.message
  }
}


export const CompanyFiltersPayload = (page, limit, filtersFormData) => {
  log('CompanyFiltersPayload', filtersFormData)
  let companyParams = {
    'page': page,
    'limit': limit
  }
  return { ...companyParams, ...filtersFormData }
}

export const PaymentRequestsFiltersPayload = (claimId, page, limit, filtersFormData) => {
  log('CompanyFiltersPayload', filtersFormData)
  log('CompanyFiltersPayload', claimId)
  let companyParams = {
    'page': page,
    'limit': limit
  }
  let claimFilter = { 'payment_claim_number': claimId?.toString() ?? '' }
  return { ...companyParams, ...claimFilter, ...filterData(filtersFormData || {}) }
}
export const PaymentReceiptsFiltersPayload = (page, limit, filtersFormData) => {
  log('CompanyFiltersPayload', filtersFormData)
  let companyParams = {
    'page': page,
    'limit': limit
  }
  return { ...companyParams, ...filterData(filtersFormData || {}) }
}

export const UsersFiltersPayload = (page, limit, filtersFormData) => {
  log('UsersFiltersPayload', filtersFormData)
  let usersParams = {
    'page': page,
    'limit': limit
  }
  return { ...usersParams, ...filtersFormData }
}

export const ReportFiltersPayload = (page, limit, filtersFormData, sortOrder) => {
  log('UsersFiltersPayload', filtersFormData)
  let usersParams = {
    'page': page,
    'limit': limit
  }
  let sortParam = {}
  if (!!Object.keys(sortOrder).length && ['subscriptions_count', 'subscribed_users_count'].includes(sortOrder.name)) {
    sortParam[`sort[${sortOrder.name}]`] = sortOrder.direction
  }
  return { ...usersParams, ...filtersFormData, ...sortParam }
}

export const UserCompaniesFiltersPayload = (page, limit, filtersFormData) => {
  log('UserCompaniesFiltersPayload', filtersFormData)
  let usersParams = {
    'page': page,
    'limit': limit
  }
  return { ...usersParams, ...filtersFormData }
}

export const exportFiltersPayload = (filtersFormData) => {
  log('exportFiltersPayload', filtersFormData)
  return { ...filtersFormData }
}


export const ServicePayload = (formData) => {
  log('ServicePayload', formData)
  let taxes = formData.allowed_taxes === 'custom' ? {
    'allowed_tax_types': {
      'monthly': formData?.allowed_taxes_monthly || [],
      'quarterly': formData?.allowed_taxes_quarterly || [],
      'midterm': formData?.allowed_taxes_midterm || [],
      'annually': formData?.allowed_taxes_annually || []
    }
  } : {}
  return {
    'title': formData.title,
    'description': formData.description,
    'category_id': formData.category_id.toString(),
    'handler_name': formData.handler_name,
    'active': formData.active,
    'is_quota_based': formData.is_quota_based || false,
    'quota_unit': !!formData.is_quota_based ? formData.quota_unit : '',
    'topups': !!formData.is_quota_based ? formData.topups || [] : [],
    'prices': !!formData.is_quota_based ? formData.quotaPrices : [
      {
        'price_duration': 'monthly',
        'price': parseFloat(formData.price_monthly) >= 0 ? formData.price_monthly.toString() : null
      },
      {
        'price_duration': 'quarterly',
        'price': parseFloat(formData.price_quarterly) >= 0 ? formData.price_quarterly.toString() : null
      },
      {
        'price_duration': 'midterm',
        'price': parseFloat(formData.price_midterm) >= 0 ? formData.price_midterm.toString() : null
      },
      {
        'price_duration': 'annually',
        'price': parseFloat(formData.price_annually) >= 0 ? formData.price_annually.toString() : null
      }
    ].filter(price => !!price.price),
    ...taxes
  }
}
export const PlanPayload = (formData) => {
  log('PlanPayload', formData)
  let taxes = formData.allowed_taxes === 'custom' ? {
    'allowed_tax_types': {
      'monthly': formData?.allowed_taxes_monthly || [],
      'quarterly': formData?.allowed_taxes_quarterly || [],
      'midterm': formData?.allowed_taxes_midterm || [],
      'annually': formData?.allowed_taxes_annually || []
    }
  } : {}
  return {
    'title': formData.title,
    'description': formData.description,
    'services': formData.services,
    'active': formData.active,
    'prices': [
      {
        'price_duration': 'monthly',
        'price': parseFloat(formData.price_monthly) >= 0 ? formData.price_monthly.toString() : null
      },
      {
        'price_duration': 'quarterly',
        'price': parseFloat(formData.price_quarterly) >= 0 ? formData.price_quarterly.toString() : null
      },
      {
        'price_duration': 'midterm',
        'price': parseFloat(formData.price_midterm) >= 0 ? formData.price_midterm.toString() : null
      },
      {
        'price_duration': 'annually',
        'price': parseFloat(formData.price_annually) >= 0 ? formData.price_annually.toString() : null
      }
    ].filter(price => !!price.price),
    ...taxes
  }
}

export const PromocodesFiltersPayload = (page, limit, filtersFormData) => {
  log('PromocodesFiltersPayload', filtersFormData)
  let promocodesParams = {
    'page': page,
    'limit': limit
  }
  return { ...promocodesParams, ...filtersFormData }
}